import { ActivityIndicator, ScrollView, StyleSheet, View } from "react-native";

import { tDetailedCart } from "tmt_api/src/types/types.validator";

import { PdModal, PdModalCloseButton, PdModalTitle } from "src/components/overlay";
import { tUseModal, useModal } from "src/providers/OverlayProvider";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { useSelector } from "react-redux";
import { PdStack, PdText } from "src/components/layout";
import { useIsMobile } from "../ui";
import { PdButton, PdButtonLabel } from "src/components/forms/button";
import { tModalComponentProps } from "src/redux/modals/types";
import api from "src/util/api";
import { navigationRef } from "src/RootNavigation";
import { kRoute } from "src/kRoute";

type tModalParams = { draftId: string };

const getDraftModalContent = (referral: tDetailedCart["draftReferral"], brandName: string) => {
  if (referral === "rep") return "Your Sales Rep has created a suggested order for your consideration.";
  if (referral === "brand") return "This Brand has created a suggested order for your consideration.";
  if (referral === "order-split")
    return `Click to view your split order from ${brandName}! If you'd like to receive this order, check out the cart as you normally would.`;
  return "";
};

const OpenDraftOrderModal: React.FC<tModalComponentProps<tModalParams>> = ({ onClose, onResolve, draftId }) => {
  const isMobile = useIsMobile();
  const rDrafts = useSelector((state) => state.DraftOrderReducer.acceptDraftResults);

  const [rDraft] = rDrafts;

  const handleOnClose = () => {
    navigationRef.current.setParams({ draftId: undefined });
    navigationRef.current.navigate(kRoute.P99);
    onClose();
  };

  const handleOnView = async () => {
    api.post({ endpoint: `/cart/${draftId}/create`, body: undefined });
    navigationRef.current.setParams({ draftId: undefined });
    onResolve();
  };

  return (
    <PdModal style={styles.modal}>
      <PdModalCloseButton onPress={handleOnClose} />
      <ScrollView contentContainerStyle={styles.modalBody}>
        {!rDraft ? (
          <View style={[styles.center, styles.wFull]}>
            <ActivityIndicator color={kColors.brandDarkGreen} size="large" />
          </View>
        ) : (
          <>
            <PdModalTitle style={styles.mb4}>{rDraft.name}</PdModalTitle>
            <PdText style={styles.mb4}>{getDraftModalContent(rDraft.draftReferral, rDraft.name)}</PdText>
            <PdStack
              layout={[1, 1]}
              isReversed={isMobile}
              direction={isMobile ? "vertical" : "horizontal"}
              gap={3}
              style={styles.wFull}
            >
              <PdButton colorScheme="purple" variant="outline" onPress={handleOnClose}>
                <PdButtonLabel>Cancel</PdButtonLabel>
              </PdButton>
              <PdButton onPress={handleOnView}>
                <PdButtonLabel>View</PdButtonLabel>
              </PdButton>
            </PdStack>
          </>
        )}
      </ScrollView>
    </PdModal>
  );
};

const useOpenDraftOrderModal = (): tUseModal<tModalParams> => {
  return useModal(OpenDraftOrderModal);
};

export default useOpenDraftOrderModal;

const styles = StyleSheet.create({
  center: {
    alignContent: "center",
    justifyContent: "center",
  },
  mb4: {
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  modal: {
    marginHorizontal: 8 * kStyleConst.kSpacing,
    maxWidth: 400,
    width: "100%",
  },
  modalBody: {
    alignItems: "flex-start",
    backgroundColor: kColors.lightBrand,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
    paddingVertical: 8 * kStyleConst.kSpacing,
  },
  wFull: {
    width: "100%",
  },
});
